module.exports = __webpack_public_path__ + "media/images/marketing/video_thumbnail4-804257674d7956082b136083265c3c9beb6221283c0326f0dadc079d7155e644.png";